import { LatLng } from "geolocation-utils";

import { Road } from "services/road";

export class SameRoads {
  private _coordinates: LatLng[] = [];

  constructor(coordinates: LatLng[]) {
    this._coordinates = coordinates;
  }

  findSameRoads() {
    const coordinates = this._coordinates;

    const seenCoordinates = new Map<string, number>();
    let allDuplicates: { location: LatLng; index: number }[][] = [];
    let currentDuplicates: { location: LatLng; index: number }[] = [];

    for (const [coordIndex, coord] of coordinates.entries()) {
      const key = JSON.stringify(coord);
      const previusCoord = coordinates.at(coordIndex - 1);

      // If Map has coord => it's duplicate => push to array group;

      if (seenCoordinates.has(key)) {
        currentDuplicates.push({ location: coord, index: coordIndex });
      } else {
        seenCoordinates.set(key, coordIndex);

        if (previusCoord) {
          const prevKey = JSON.stringify(previusCoord);

          // Creat new group if duplicates has been interrupted;
          if (seenCoordinates.has(prevKey)) {
            if (currentDuplicates.length > 0) {
              allDuplicates.push(currentDuplicates);
              currentDuplicates = [];
            }
          }
        }
      }
    }

    // Filter by distance;
    allDuplicates = allDuplicates.filter((duplicates) => {
      const coords = duplicates.map((item) => item.location);
      const road = Road.fromLatLng(coords);
      return road.getDistance("km") > 5;
    });

    // Create array of indexes: [startIndexInCoords, endIndexInCoords];
    const indexes = allDuplicates.map((duplicates) => {
      return [duplicates[0].index, duplicates[duplicates.length - 1].index];
    });

    const data = {
      indexes,
      coordinates: allDuplicates.map((duplicates) =>
        duplicates.map((item) => item.location)
      ),
    };

    return data;
  }
}
